import { AuthClient, StuutApi } from '@stuut/api';

const STUUT_AUTH_COOKIE = process.env.STUUT_AUTH_COOKIE || 'stuut.auth_token.test';
const STUUT_REFRESH_TOKEN_FLAG_COOKIE =
  process.env.STUUT_REFRESH_TOKEN_FLAG_COOKIE || 'stuut.refresh_token_exists.test';
const LOGIN_REDIRECT_URI = `${window.location.origin}/auth/callback`;
const LOGOUT_URI = `${window.location.origin}/sign-in`;

export const stuut = new StuutApi(process.env.STUUT_API_URL || '');

export const authClient = new AuthClient({
  api: stuut,
  auth0Config: {
    audience: process.env.STUUT_AUTH0_API_IDENTIFIER || '',
    clientID: process.env.STUUT_AUTH0_CLIENT_ID || '',
    domain: process.env.STUUT_AUTH0_DOMAIN || '',
    redirectUri: LOGIN_REDIRECT_URI,
  },
  cookies: {
    authToken: STUUT_AUTH_COOKIE,
    refreshTokenFlag: STUUT_REFRESH_TOKEN_FLAG_COOKIE,
  },
  logoutUri: LOGOUT_URI,
});
